import React from 'react'

import { Box, BoxProps } from '../Box'

export interface BackgroundImageProps extends Omit<BoxProps, 'size' | 'position'> {
  src?: string
  size?: BoxProps['backgroundSize']
  position?: BoxProps['backgroundPosition']
  repeat?: BoxProps['backgroundRepeat']
}

export const BackgroundImage = ({
  src,
  position,
  size,
  repeat = 'no-repeat',
  ...restProps
}: BackgroundImageProps) => {
  console.log('src', src)
  return (
    <Box
      bgImage={`url("${src}")`}
      bgPos={position}
      bgSize={size}
      backgroundRepeat={repeat}
      {...restProps}
    />
  )
}

export default BackgroundImage
